import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    group: String,
    animation: { type: Number, default: 150 },
    handle: { type: String, default: ".drag-handle" },
  };

  declare readonly groupValue: string;
  declare readonly animationValue: number;
  declare readonly handleValue: string;

  connect() {
    this.initializeSortable();
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  private sortable: Sortable | null = null;

  private initializeSortable() {
    this.sortable = new Sortable(
      this.element as HTMLElement,
      this.getSortableOptions(),
    );
  }

  protected getSortableOptions(): Sortable.Options {
    return {
      group: this.groupValue,
      animation: this.animationValue,
      handle: this.handleValue,
      onEnd: this.onEnd.bind(this),
    };
  }

  protected async onEnd(event: Sortable.SortableEvent) {
    if (event.oldIndex === event.newIndex) return;

    const id = event.item.dataset.id;
    const url = event.item.dataset.sortableUrl;
    if (!id || !url) return;

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token":
            document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute("content") || "",
        },
        body: JSON.stringify(this.getUpdatePayload(event)),
      });

      if (!response.ok) {
        throw new Error("Failed to update position");
      }
    } catch (error) {
      console.error("Error updating position:", error);
      // Revert the sort if the request fails
      this.revertSort();
    }
  }

  protected getUpdatePayload(event: Sortable.SortableEvent): object {
    return {
      [this.groupValue]: {
        position: event.newIndex! + 1,
      },
    };
  }

  protected revertSort() {
    if (this.sortable) {
      const items = Array.from(this.element.children).map((item) => item.id);
      this.sortable.sort(items);
    }
  }
}
